<template>
  <!-- banner topo -->
  <div v-if="bannerTopo != ''" class="bannerTopo-area">
    <div class="bannerTopo-height d-flex align-items-center">

      <div class="bannerTopo-img">
        <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bannerTopo-bg-fill" alt="">
      </div>


      <div class="bannerTopo-overlay"></div>

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8 col-lg-10">
            <div class="bannerTopo-caption text-center">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--=== sobre a empresa ========================-->
  <div class="about-area section-bg">
    <div class="container">

      <div v-if="sobre != ''" class="row align-items-center mb-80">
        <div class="col-xl-6 col-lg-6 col-md-12">
          <div class="about-img-sobre">
            <img :src="$imgURL + sobre[0].insInstitucionalImagens[0].itgUrlImagem" class="w-100 shadow-sm" alt="">
          </div>
        </div>
        <div class="col-xl-5 col-lg-6 col-md-12 offset-xl-1">
          <div class="about-cap-right">
            <div class="section-tittle">
              <h2>{{ sobre[0].itiNome }}</h2>
              <p v-html="sobre[0].itiResumo2"></p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="missaoVisao != ''" class="row">
        <div v-for="missao in missaoVisao" :key="missao.itiId" class="col-xl-4 col-lg-4 col-md-6 mb-30">
          <div class="card-lider">
            <h4>{{ missao.itiNome }}</h4>
            <p v-html="missao.itiResumo1"></p>
          </div>
        </div>
      </div>

    </div>
  </div>

  <PageCallAction></PageCallAction>

</template>

<script>
import PageCallAction from '../components/PageCallAction.vue';
import { useHead } from '@vueuse/head';
import axios from 'axios';

export default {
  name: 'SobreView',
  components: {
    PageCallAction,
  },

  data: () => ({
    bannerTopo: [],
    sobre: [],
    missaoVisao: [],
  }),

  methods: {
    carregaMetas(texto, titulo) {
      useHead({
        title: 'Lukon :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
  },

  created() {
    this.carregaMetas("---");

    // TOPO BANNER
    axios.get('/Process/InsInstitucional/institucional/11/toposobre/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML, this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // SOBRE
    axios.get('/Process/InsInstitucional/institucional/12/textosobre/0/x')
      .then(response => {
        this.sobre = response.data;
        //console.log('sobre')
        //console.log(this.sobre)
      })
      .catch(error => {
        console.error(error);
      });

      // MISSAO VISAO
    axios.get('/Process/InsInstitucional/institucional/14/itensdosobre/0/x')
      .then(response => {
        this.missaoVisao = response.data;
        //console.log('missaoVisao')
        //console.log(this.missaoVisao)
      })
      .catch(error => {
        console.error(error);
      });

  }

}
</script>

<style scoped></style>